import React, {useCallback, useState} from 'react';
import PropTypes from 'prop-types';
import cl from 'classnames';
import UtilsHelper from '../../../utils/utils-helper';
import {NotificationError} from '../../../services/notifications';
import {AttachedFile, FileRemoveIcon} from '../../SvgComponents/SvgComponents';
import './FilePickerInline.less';

function FilePickerInline({
  onChange, attachedFile, maxSize, allowedExtensions, disabled, wrapStyles, styles, fileLink, onRemoveFileLink,
  fileName, placeholder,
}) {
  const onAttachFile = useCallback((e) => {
    const file = e.target.files[0];
    if (!file) {
      return null;
    }
    const fileExtension = file.name.split('.').pop().toLowerCase();
    const isValidExtension = UtilsHelper.isAllowedFormat(fileExtension, allowedExtensions);
    if (!isValidExtension || !fileExtension) {
      NotificationError(`Допустимые расширения файла: ${allowedExtensions.join(', ')}`);
      return null;
    }
    if (file.size >= maxSize * 1000000) {
      NotificationError(`Размер файла должен быть не более ${maxSize} мб`);
      return null;
    }
    if (file) {
      onChange(file);
    }
    return null;
  }, [allowedExtensions, maxSize, onChange]);

  const onRemoveFile = useCallback((e) => {
    e.preventDefault();
    e.stopPropagation();
    if (fileLink) {
      onRemoveFileLink();
    } else {
      onChange(null);
    }
  }, [onChange, fileLink, onRemoveFileLink]);

  return (
    <div className="file-picker-inline_wrap" style={wrapStyles}>
      <label
        htmlFor="attach-file"
        style={styles}
        className={cl('file-picker-inline', {
          disabled,
        })}
      >
        <span className="file-picker-inline_attached-icon">
          <AttachedFile />
        </span>
        {fileLink && (<a href={fileLink} target="_blank" className="file-picker-inline_link">{fileName}</a>)}
        {!fileLink && (
          <span>
            {attachedFile ? attachedFile.name : placeholder}
          </span>
        )}

        {(attachedFile || fileLink) && !disabled && (
          <button
            type="button"
            className="file-picker-inline_remove"
            onClick={onRemoveFile}
          >
            <FileRemoveIcon />
          </button>
        )}
        {!fileLink && (
          <input
            disabled={disabled}
            type="file"
            id="attach-file"
            className="attach-file"
            onChange={onAttachFile}
          />
        )}
      </label>
    </div>
  );
}

FilePickerInline.defaultProps = {
  allowedExtensions: [],
  maxSize: 5,
  fileLink: '',
  onChange: () => {},
  attachedFile: null,
  disabled: false,
  wrapStyles: {},
  styles: {},
  fileName: 'файл',
  placeholder: 'Прикрепить файл',
};

FilePickerInline.propTypes = {
  maxSize: PropTypes.number,
  fileLink: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  onRemoveFileLink: PropTypes.func,
  wrapStyles: PropTypes.shape({}),
  styles: PropTypes.shape({}),
  allowedExtensions: PropTypes.arrayOf(PropTypes.string),
};

export default FilePickerInline;
